<template>
  <div>
    <v-btn
      fixed
      dark
      fab
      bottom
      right
      color="accent"
      @click="$emit('showAddDialog')"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-container fluid class="pb-0">
      <v-sheet elevation="1" class="header-bar">
        <v-layout row class="align-center" wrap>
          <v-flex xs12 lg6>
            <v-text-field
              label="Recherche..."
              append-icon="search"
              v-model="search"
              @input="$emit('update', { ...$data, search })"
            />
          </v-flex>
          <v-flex
            xs12
            lg6
            class="d-inline-flex justify-end d-flex-initial align-center"
          >
            <v-btn-toggle
              v-model="filter"
              mandatory
              @change="$emit('update', { ...$data, filter: $event })"
              style="box-shadow: none"
              v-if="$mq === 'lg'"
            >
              <v-btn
                flat
                v-for="s in allStatus"
                :key="s.value"
                :value="s.value"
              >
                {{ s.text }}
              </v-btn>
            </v-btn-toggle>
            <v-select
              v-else
              style="width: 100%"
              label="État"
              :items="allStatus"
              v-model="filter"
              @change="$emit('update', { ...$data, filter: $event })"
            />
            <v-btn v-if="isAdminOrSuperAdmin" @click="downloadProspects">
              <v-icon left class="hidden-sm-and-down">cloud_download</v-icon>
              Télécharger
            </v-btn>
          </v-flex>
          <v-flex xs12 v-if="$mq === 'sm'">
            <v-select
              style="width: 100%"
              label="Colonne"
              :items="allColumns"
              v-model="column"
              @change="$emit('update', { ...$data, column: $event })"
            />
          </v-flex>
        </v-layout>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { fetchHil } from "@/utils";
import * as _ from "lodash";
import { mapGetters } from "vuex";

import { downloadFile } from "../../../webapp-commons/functions";
import {
  ALL_PROSPECTS_COLUMNS,
  DEFAULT_PROSPECTS_FILTERS_SETTINGS
} from "../data/DefaultSettings";

export default {
  name: "ProspectsFilter",
  computed: {
    ...mapGetters("user", ["isAdmin", "isSuperAdmin", "isAdminOrSuperAdmin"]),
    allColumns() {
      if (this.isSuperAdmin) {
        return ALL_PROSPECTS_COLUMNS;
      } else if (this.isAdmin) {
        return ALL_PROSPECTS_COLUMNS.filter(
          ({ superAdminOnly }) => !superAdminOnly
        );
      } else {
        return ALL_PROSPECTS_COLUMNS.filter(
          ({ superAdminOnly, adminOnly }) => !superAdminOnly && !adminOnly
        );
      }
    },
    allStatus() {
      return [
        { text: "Actifs", value: "active" },
        { text: "Abandonnés", value: "stopped" },
        { text: "Tous", value: "all" }
      ];
    }
  },
  data: function() {
    return DEFAULT_PROSPECTS_FILTERS_SETTINGS;
  },
  methods: {
    async downloadProspects() {
      const qs = new URLSearchParams(
        _.pickBy(
          {
            search: this.search,
            filter: this.filter
          },
          v => v !== undefined && v !== ""
        )
      );
      const data = await fetchHil(`/reports/prospects?${qs}`);
      await downloadFile(data);
    }
  }
};
</script>
